export const PERFORMANCE_AREA = "PERFORMANCE_AREA";
export const PERFORMANCE_AREA_SUCCESS = "PERFORMANCE_AREA_SUCCESS";
export const PREPSCORE = "PREPSCORE";
export const GET_WHERE_YOU_LEFT = "GET_WHERE_YOU_LEFT";
export const GET_EXAM_DATES = "GET_EXAM_DATES";
export const SET_EXAM_DATE = "SET_EXAM_DATE";   
export const GET_CHART_DATA = "GET_CHART_DATA";
export const GET_CHART_DATA_SUCCESS = "GET_CHART_DATA_SUCCESS";
export const GET_DRUG_CHART = "GET_DRUG_CHART";